import React, { useState } from 'react';
import { Box, Grid, Typography, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { AddIcon, PersonOutlineOutlinedIcon, InsertPhotoOutlinedIcon, VideocamOutlinedIcon, LinkOutlinedIcon } from 'icons/materialIcons';
import TeamDarkButtonWithIcon from 'team/shared/components/button/TeamDarkButtonWithIcon';

const TeamAssetsNavbar = ({ onSelectAssetType }) => {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleMenuSelect = (assetType) => {
        if (onSelectAssetType) {
            onSelectAssetType(assetType);
        }
        handleMenuClose();
    };

    return (
        <Box sx={{ padding: '1rem' }}>
            <Grid container spacing={2} alignItems="center" >
                <Grid item xs={12} sm="auto">
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '0.6rem', flexWrap: 'nowrap' }}>
                        <Typography sx={{ fontSize: '1.3rem', color: '#333' }}>
                            Team Assets
                        </Typography>
                        <Typography sx={{ fontSize: '0.9rem', color: '#666' }}>
                            Allow your team to design their Touch accounts in a way that matches your brand
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm container justifyContent="flex-end">
                    <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                            <TeamDarkButtonWithIcon
                                text="Create a Team Asset"
                                icon={<AddIcon />}
                                iconPosition="start"
                                onClick={handleMenuOpen}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Menu
                anchorEl={menuAnchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        padding: '0.25rem',
                        marginTop: '0.5rem'
                    }
                }}
            >
                <MenuItem onClick={() => handleMenuSelect('logo')}>
                    <ListItemIcon>
                        <PersonOutlineOutlinedIcon sx={{ fontSize: 20, color: '#4f4f4f' }} />
                    </ListItemIcon>
                    <ListItemText primary="Logo" />
                </MenuItem>
                <MenuItem onClick={() => handleMenuSelect('coverPhoto')}>
                    <ListItemIcon>
                        <InsertPhotoOutlinedIcon sx={{ fontSize: 20, color: '#4f4f4f' }} />
                    </ListItemIcon>
                    <ListItemText primary="Cover Photo" />
                </MenuItem>
                <MenuItem onClick={() => handleMenuSelect('virtualBackground')}>
                    <ListItemIcon>
                        <VideocamOutlinedIcon sx={{ fontSize: 20, color: '#4f4f4f' }} />
                    </ListItemIcon>
                    <ListItemText primary="Virtual Background" />
                </MenuItem>
                <MenuItem onClick={() => handleMenuSelect('linkIcon')}>
                    <ListItemIcon>
                        <LinkOutlinedIcon sx={{ fontSize: 20, color: '#4f4f4f' }} />
                    </ListItemIcon>
                    <ListItemText primary="Link Icon" />
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default TeamAssetsNavbar;
